import { createCustomerPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { CURRENCIES } from '@vy/types';
import { values } from '@vy/utils';
import React from 'react';
import type { StyledTextField } from '../StyledTextField';
import { BaseSelect } from './BaseSelect';

type CurrenciesSelectProps = Omit<React.ComponentProps<typeof StyledTextField>, 'options'> & {
  textFieldProps?: React.InputHTMLAttributes<HTMLInputElement>;
};

export const CurrenciesSelect = React.forwardRef<HTMLInputElement, CurrenciesSelectProps>((props, ref) => {
  return (
    <BaseSelect
      {...getSelectorAttribute(createCustomerPageSelectors.configuration.currency)}
      {...props}
      ref={ref}
      values={values(CURRENCIES)}
      label="Currency"
      withNone={false}
    />
  );
});
